export const orderTableHeader = ['name', 'sku', 'quantityOnHand', 'test', 'inclPrice', 'total'];

export const returnTableHeader = ['name', 'sku', 'quantity', 'reason', 'returnAmount', 'total'];
